var _circle, _rect, _line, _circle2, _circle3, _circle4, _line2, _line3, _line4, _line5, _line6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "url(#paint0_linear_316_5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 43.5,
    width: 65,
    height: 53,
    rx: 7.5,
    stroke: "#CAEBEB",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 60.5,
    x2: 100,
    y2: 60.5,
    stroke: "#CAEBEB",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 52,
    r: 3,
    fill: "#CAEBEB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 52,
    r: 3,
    fill: "#CAEBEB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 52,
    r: 3,
    fill: "#CAEBEB"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 7.77776,
    y2: -1.5,
    transform: "matrix(-0.8 0.599999 -0.714359 -0.699779 73.2223 75.3333)",
    stroke: "#CAEBEB",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 8.64383,
    y2: -1.5,
    transform: "matrix(0.719845 0.694135 -0.795432 0.606043 67 79.9999)",
    stroke: "#CAEBEB",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 7.77776,
    y2: -1.5,
    transform: "matrix(0.8 -0.599999 0.714359 0.699779 88.7777 88.6665)",
    stroke: "#CAEBEB",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 8.64383,
    y2: -1.5,
    transform: "matrix(-0.719845 -0.694135 0.795432 -0.606043 95 83.9999)",
    stroke: "#CAEBEB",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 22.0705,
    y2: -1.5,
    transform: "matrix(-0.422886 0.906183 -0.945946 -0.324324 85.6667 70)",
    stroke: "#CAEBEB",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_5",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ADAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18CAA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontendIcon);
export default __webpack_public_path__ + "static/media/frontend-icon.ba3c626bc49cd129c303734eedb5034e.svg";
export { ForwardRef as ReactComponent };